import { useEffect, useLayoutEffect, useState } from 'react';

const useResize = () => {
  const [size, setSize] = useState<number>(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  const breakpoint = {
    lg: 1350,
    md: 640,
  };

  const handleResize = () => {
    // 手機內容溢出會放大 innerWidth；以 layout viewport 避免誤用桌面排版。
    const width = document.documentElement.clientWidth || window.innerWidth;

    setSize(width);
    setIsMobile(width < breakpoint.md);
    setIsTablet(width < breakpoint.lg);
  };

  // ⭐ useLayoutEffect 會在畫面更新前觸發
  useLayoutEffect(() => {
    handleResize(); // 抓第一次畫面大小
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { size, breakpoint, isMobile, isTablet };
};

export default useResize;
